import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  convertAmount,
  GameSection,
  GameStructure,
  getAmountWithCurrency,
  PlayForRealPopup,
  useSoundWatcher,
  gameConfigStore,
} from '@pascal/pascal-core';

import { HeaderWr } from './header';

import {
  AdditionalResponseCode,
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
} from '../enums/notifications';
import WebGameMain from '../game/web';
import FooterWr from './footer';
import gameLogo from '../assets/images/logo-loading-png.png';
import demoLogo from '../assets/images/demo-logo.png';
import { useVisibilityChange } from '../hooks/useVisibilityChange';
import { PayoutsAndResultsContainer } from './payoutsAndResultsContainer';

export const WebGame = observer(() => {
  useSoundWatcher();
  useVisibilityChange();

  const {
    limits: { minBet, maxBet },
  } = gameConfigStore;

  return (
    <GameStructure lobbyLogoImageSrc={gameLogo} hasGameTypeLoading hasLobby isShowBogLineLobby>
      <HeaderWr />
      <GameSection
        haveNotification
        AdditionalResponseCode={AdditionalResponseCode}
        AdditionalErrorMessages={AdditionalErrorMessages}
        AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
        translationValues={{
          minBet: getAmountWithCurrency({ amount: convertAmount(minBet) }),
          maxBet: getAmountWithCurrency({ amount: convertAmount(maxBet) }),
        }}
      >
        <WebGameMain />
        <PayoutsAndResultsContainer />
      </GameSection>
      <FooterWr />
      <PlayForRealPopup popupLogo={demoLogo} />
    </GameStructure>
  );
});
